import { render } from "./CreateMessage.vue?vue&type=template&id=4d7cc4e4"
import script from "./CreateMessage.vue?vue&type=script&lang=js"
export * from "./CreateMessage.vue?vue&type=script&lang=js"

import "./CreateMessage.vue?vue&type=style&index=0&id=4d7cc4e4&lang=css"

import exportComponent from "/Users/jay/Downloads/exp/hl/msgui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__